<template>
  <div>  
    <div class="row mb-4 mt-4 ml-1">
      <div class="col-md-3 mb-3">
        <div class="card clickable" style="border-left:5px solid skyblue" @click="go('/ministryrequests')">
          <img src="../assets/records.png" width="30%" class="mx-3 my-3"/>
          <h5>View Sign Ups</h5>
          <p>For Ministry Leaders to view and process candidates who signed up for ministries.</p>
        </div>
      </div>
      <div class="col-md-3 mb-3" v-show='isAdmin'>
        <div class="card clickable" style="border-left:5px solid red" @click="go('/account')">
          <img src="../assets/access.png" width="30%" class="mx-3 my-3"/>
          <h5>Account & Access</h5>
          <p>For Administrators to create accounts and grant ministry role access to account holders.</p>
        </div>
      </div>
         
      <div class="col-md-3 mb-3" v-show='isAdmin'>
        <div class="card clickable" style="border-left:5px solid green" @click="go('/uploadrole')">
          <img src="../assets/excel.png" width="30%" class="mx-3 my-3"/>
          <h5>Bulk Upload Roles</h5>
          <p>For Administrators to bulk upload departments and roles available for sign ups.</p>
        </div>
      </div>

      <div class="col-md-3 mb-3" v-show='isAdmin'>
        <div class="card clickable" style="border-left:5px solid grey" @click="go('/systemconfig')">
          <img src="../assets/setting.png" width="30%" class="mx-3 my-3"/>
          <h5>System Configuration</h5>
          <p>For Administrators to view and manage system's configuration.<br><br></p>
        </div>
      </div>   
      <div class="col-md-3 mb-3" v-show='isAdmin'>
        <div class="card clickable" style="border-left:5px solid purple" @click="go('/report')">
          <img src="../assets/chart.png" width="30%" class="mx-3 my-3"/>
          <h5>Report Summary (More coming up!)</h5>
          <p>Display a range of preset charts for quick overview.<br><br></p>
        </div>
      </div>  
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <button class="btn btn-primary mx-3" v-on:click="changepassword">Change Password</button>
        <button class="btn btn-danger mx-3" v-on:click="logout">Log Out</button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  data: function() {
    return {
      isAdmin:false
    };
  },
  methods: {
    changepassword: function() {
      this.$router.push("/changepassword");
    },

    logout: async function() {
      let token = http.getToken();
      try {
        await http.post("/account/logout", { token: token }); // Delete from MRS
        http.clearToken(); // Clear browser's config
      } catch (err) {
        console.error("log out err", err);
      }
      this.$router.push("/adminlogin");
    },
    go: function(path) {
      location.href = "#" + path;
    }
  },
  beforeMount: async function() {

    // Check if logged in
    if (!(await http.isLoggedIn())) {
      this.$router.push("/adminlogin");
    }

    // Check if is administrator
    if(await http.isLoggedIn(true)){
      this.isAdmin = true;
    }
  }
};
</script>

<style>
.admin-options {
  border-radius: 25px;
  border: 2px solid #73ad21;
  padding: 20px;
  width: 200px;
  height: 150px;
}


</style>
